import Help from '@mui/icons-material/Help';
import SettingsIcon from '@mui/icons-material/Settings';
import {
  Avatar,
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  InputAdornment,
  MenuItem,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import downloadIcon from 'assets/exportPDF.png';
import reloadIcon from 'assets/reload.png';
import teamsIcon from 'assets/teams.png';
import userManualIcon from 'assets/userManual.png';
import { PATHS } from 'constants/paths';
import isEmpty from 'lodash/isEmpty';
import UserRoleSettingsModal from 'pages/WellGuardian/WIR/UserRoleSettingsModal';
import { useUserRoleSettingsModalData } from 'pages/WellGuardian/WIR/UserRoleSettingsModal/hooks';
import { getPhaseName } from 'pages/WellGuardian/WIR/WIRInterventions/components/WIRSchedule/utils';
import WIRField from 'pages/WellGuardian/WIR/components/WIRField';
import { getIsSuperUser } from 'pages/WellGuardian/WIR/utils';
import { NOT_APPLICABLE, StatusTypes } from 'pages/WellGuardian/WIR/wir.constants';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { generatePath, Link, useLocation, useNavigate } from 'react-router-dom';
import { useSelectUser } from '../../redux/User/selectors';
import {
  updateAllReviewsDownload,
  updateAllWIRUsers,
  updateCountryState,
  updateMapCountryState,
  updateSelectedAsset,
  updateSelectedSite,
  updateSortedWells,
  updateWIRUsers,
} from '../../redux/WellGuardian';
import {
  useAllWellReviewsDownload,
  useAllWirUsers,
  useCountryState,
} from '../../redux/WellGuardian/selectors';
import wellGuardianApiClient from 'services/networking/wellGuardianApiClient';
import {
  ALL_COUNTRIES_LIST,
  AssetType,
  COUNTRY_CODE,
  CountryData,
  pendingPhase,
  riskStatus,
  SiteType,
  UserDTO,
  WIRUser,
} from 'types/wellGuardian';

import styles from './HeaderWellGuardian.module.scss';
import BasicHeader from './components/BasicHeader';
import BasicHeaderWirCreateIntervention from './components/BasicHeaderWirCreateIntervention';
import CountryFlagIcon from './components/CountryFlagIcon/CountryFlagIcon';
import WellGuardianToolbar from './components/WellGuardianToolbar';
import { countryListCheck } from './components/WellGuardianToolbar/utils/countryListCheck';
import {
  getIsInterventionsWirCreation,
  getIsWellHealthSubModule,
} from './components/WellGuardianToolbar/utils/toolbarUtils';
import WellHealthHeader from './components/WellHealthHeader';
import { toNormalCase } from 'helpers/stringHelpers';
import userApiClient from 'services/networking/userApiClient';

const READ_ONLY_WIR_USER = 'READ_ONLY_WIR_USER';
const DROPDOWN_COUNTRIES: CountryData[] = [...ALL_COUNTRIES_LIST.data];
const COUNTRY_DROPDOWN_USERS = [
  {
    email: 'venkata.madana@external.totalenergies.com',
    iggs: ['L1075448', 'venkata.madana@external.totalenergies.com'],
  },
  {
    email: 'samir.kale@external.totalenergies.com',
    iggs: ['L1079878', 'samir.kale@external.totalenergies.com'],
  },
  {
    email: 'subhanjan.kar@external.totalenergies.com',
    iggs: ['L1144140', 'subhanjan.kar@external.totalenergies.com'],
  },
  {
    email: 'pankaj.jagetiya@external.totalenergies.com',
    iggs: ['L1183370', 'pankaj.jagetiya@external.totalenergies.com'],
  },
];

const URLData = {
  UserManual: `https://totalworkplace.sharepoint.com/:f:/r/sites/TEPUKDD-WellGuardianUsers418/Documents%20partages/General/Release%20Notes?csf=1&web=1&e=Qw6fmp`,
  TeamsWI_UK: `https://teams.microsoft.com/l/channel/19%3A92f1c90018804c87aa24ee4d2e2eefe4%40thread.tacv2/Digital%20WIR?groupId=c4c4c3ca-e073-4133-8f1f-3358dcd20bf3&tenantId=`,
  TeamsWH_UK: `https://teams.microsoft.com/l/channel/19%3ATUuboYhsRE-3m8hoJKI-cXXaIeFJ8J_iREFrJsJ4Imc1%40thread.tacv2/General?groupId=c4c4c3ca-e073-4133-8f1f-3358dcd20bf3&tenantId=`,
  TeamsWH_DK: `https://teams.microsoft.com/l/channel/19%3Af4fe571fa6f843aba782fe241c0c6996%40thread.tacv2/WG%20-%20Denmark?groupId=c4c4c3ca-e073-4133-8f1f-3358dcd20bf3&tenantId=&ngc=true`,
  TeamsWH_NG: `https://teams.microsoft.com/l/channel/19%3Aecc71f1e6bb54d708cbce8529d6ccc73%40thread.tacv2/WG%20-%20Nigeria?groupId=c4c4c3ca-e073-4133-8f1f-3358dcd20bf3&tenantId=&ngc=true`,
  TeamsWH_AG: `https://teams.microsoft.com/l/channel/19%3A3ff2fbee69cf4ce380eea9451215966d%40thread.tacv2/WG%20-%20Angola?groupId=c4c4c3ca-e073-4133-8f1f-3358dcd20bf3&tenantId=&ngc=true`,
  TeamsWH_CG: `https://teams.microsoft.com/l/channel/19%3Ae7a9a0281d8348d3bd5fa515351b41b2%40thread.tacv2/WG%20-%20Congo?groupId=c4c4c3ca-e073-4133-8f1f-3358dcd20bf3&tenantId=&ngc=true`,
  TeamsWH_BZ: `https://teams.microsoft.com/l/channel/19%3A59bb2778d29347adb33205dc3fd87c94%40thread.tacv2/WG%20-%20Brazil?groupId=c4c4c3ca-e073-4133-8f1f-3358dcd20bf3&tenantId=&ngc=true`,
  TeamsWH_IQ: `https://teams.microsoft.com/l/channel/19%3A2379c0e9c34349e7b7daef237676e59f%40thread.tacv2/WG%20-%20Iraq?groupId=c4c4c3ca-e073-4133-8f1f-3358dcd20bf3&tenantId=329e91b0-e21f-48fb-a071-456717ecc28e&ngc=true`,
  TeamsWH_AR: ``,
};

const getWellGuardianHeader = (path: string) => {
  const isWellHealthSubModule = getIsWellHealthSubModule(path);
  const isInterventionsWirCreation = getIsInterventionsWirCreation(path);

  if (isWellHealthSubModule) return <WellHealthHeader />;
  if (isInterventionsWirCreation) return <BasicHeaderWirCreateIntervention />;

  return <BasicHeader />;
};

type HeadCell = {
  id: string;
  label: string | null;
  width?: string;
};

const headCells: HeadCell[] = [
  { id: 'WIR Number', label: 'WIR Number' },
  { id: 'Pending', label: 'Pending Tasks' },
  { id: 'Well', label: 'Well Name' },
  { id: 'Current Phase', label: 'Current Phase' },
  { id: 'status', label: 'Status' },
  { id: 'Intervention Engineer', label: 'Intervention Engineer' },
];

const handleLinkChange = () => PATHS.HOME;

const hasDirectoryUser = (directoryUsers: UserDTO[], user: UserDTO) => {
  const userEmail = user.email?.trim().toLowerCase();
  return Boolean(
    userEmail &&
      directoryUsers.some(
        directoryUser => directoryUser.email?.trim().toLowerCase() === userEmail,
      ),
  );
};

const HeaderWellGuardian: React.FunctionComponent = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const user = useSelectUser();

  const allWirUsers = useAllWirUsers();
  const canSelectCountry = COUNTRY_DROPDOWN_USERS.some(
    account =>
      account.email === user?.email?.trim().toLowerCase() &&
      account.iggs.some(igg => igg.toLowerCase() === user?.igg?.trim().toLowerCase()),
  );
  const [wirUsers, setWirUsers] = useState<WIRUser[]>([]);
  const { openUserRoleSettingsModal, setOpenUserRoleSettingsModal } =
    useUserRoleSettingsModalData();
  const [count, setCount] = useState<boolean>(false);
  const dispatch = useDispatch();
  const countryState = useCountryState();
  const countryCodeValue = localStorage.getItem(COUNTRY_CODE);
  const isSuperUserOnWirSubModule = getIsSuperUser(
    wirUsers,
    user,
    countryCodeValue ?? countryState,
  );
  const [pendingStatus, setPendingStatus] = useState<riskStatus[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalCount, setTotalCount] = useState<number>(0);

  const [countryList, setCountryList] = useState<CountryData[]>([]);
  const [value, setValue] = useState<string>('');
  const [selectedCountry, setSelectedCountry] = useState<CountryData | null>(null);
  const [searchText, setSearchText] = useState<string>('');
  const [isCountryLoading, setIsCountryLoading] = useState<boolean>(false);
  const [isDecommissioned, setIsDecommissioned] = useState(false);
  const [isUserInDirectory, setIsUserInDirectory] = useState(true);
  const [isCheckingAffiliateAccess, setIsCheckingAffiliateAccess] = useState(false);
  const [confirmedNoUkAccessForUser, setConfirmedNoUkAccessForUser] = useState<string | null>(null);
  const [affiliateAccessCheckFailed, setAffiliateAccessCheckFailed] = useState(false);
  const [dismissedAffiliateNotice, setDismissedAffiliateNotice] = useState<string | null>(null);
  const downloadValue = useAllWellReviewsDownload();

  useEffect(() => {
    const fetchData = async () => {
      if (countryState === '') return;
      setLoading(true);
      setTotalCount(0);
      if (user && countryState !== '') {
        const res = await wellGuardianApiClient.getPendingTasks(countryState, 'NA');
        const data = res.filter(
          x =>
            x.state !== 'INTERVENTION_COMPLETE' &&
            x.pendingAction.some(
              (action: any) => action.userId === user.igg && action.pendingSubtaskCount > 0,
            ),
        );
        setPendingStatus(data);
        setTotalCount(data.length);
      }
      setLoading(false);
    };

    fetchData();
  }, [countryState, user]);

  useEffect(() => {
    const refetchData = async () => {
      if (countryState === '') return;
      setLoading(true);
      if (user && count) {
        const res = await wellGuardianApiClient.getPendingTasks(countryState, 'NA');
        const data = res.filter(
          x =>
            x.state !== 'INTERVENTION_COMPLETE' &&
            x.pendingAction.some(
              (action: any) => action.userId === user.igg && action.pendingSubtaskCount > 0,
            ),
        );
        setPendingStatus(data);
        setTotalCount(data.length);
      }
      setLoading(false);
      setCount(false);
    };

    refetchData();
  }, [countryState, user, count]);

  const wirPath = window.location.pathname.split('/')[3];
  const affiliateInContext = [
    value,
    wirPath ? decodeURIComponent(wirPath) : '',
    countryState,
    countryCodeValue,
  ].find(affiliate => DROPDOWN_COUNTRIES.some(country => country === affiliate));
  const country = selectedCountry || affiliateInContext || CountryData.unitedKingdom;
  const canContinueToAffiliate =
    canSelectCountry && countryList.length > 0 && country !== CountryData.unitedKingdom;

  const applyAffiliateAccess = useCallback(
    (allUsers: WIRUser[], preferredCountry = value, isUserInDirectory = true) => {
      if (!user) return;
      setIsUserInDirectory(isUserInDirectory);
      const accessibleCountries = countryListCheck(allUsers, user);
      const explicitCountry = DROPDOWN_COUNTRIES.find(affiliate => affiliate === preferredCountry);
      const canUseExplicitCountry =
        explicitCountry &&
        (accessibleCountries.includes(explicitCountry) ||
          (canSelectCountry && explicitCountry !== CountryData.unitedKingdom));
      const nextCountry =
        accessibleCountries.length === 0
          ? undefined
          : canUseExplicitCountry
            ? explicitCountry
            : accessibleCountries.includes(CountryData.unitedKingdom)
              ? CountryData.unitedKingdom
              : accessibleCountries.find(affiliate => affiliate === country) ||
                accessibleCountries[0];

      setSelectedCountry(nextCountry ?? null);
      setCountryList(
        accessibleCountries.length === 0
          ? []
          : canSelectCountry
            ? DROPDOWN_COUNTRIES
            : accessibleCountries,
      );
      const noticeKey = `${user.email}:${user.igg}:${nextCountry}`;
      setIsDecommissioned(
        !isUserInDirectory ||
          !nextCountry ||
          (nextCountry !== CountryData.unitedKingdom &&
            !(canSelectCountry && dismissedAffiliateNotice === noticeKey)),
      );
      if (nextCountry) {
        localStorage.setItem(COUNTRY_CODE, nextCountry);
        dispatch(updateCountryState(nextCountry));
        dispatch(updateWIRUsers(allUsers.filter(x => x.country === nextCountry)));
        if (nextCountry !== country) {
          dispatch(updateMapCountryState(false));
          dispatch(updateSelectedSite('ALL' as SiteType));
          dispatch(updateSelectedAsset('ALL' as AssetType));
          dispatch(updateSortedWells([]));
          navigate(PATHS.HOME);
        }
      } else {
        dispatch(updateWIRUsers([]));
      }
      setWirUsers(allUsers);
      if (allUsers.length > 0 && allUsers !== allWirUsers) {
        dispatch(updateAllWIRUsers(allUsers));
      }
    },
    [
      user,
      allWirUsers,
      canSelectCountry,
      dispatch,
      country,
      dismissedAffiliateNotice,
      value,
      navigate,
    ],
  );

  const fetchUsersList = useCallback(async () => {
    if (!user) return;

    setIsCountryLoading(true);
    setAffiliateAccessCheckFailed(false);
    try {
      const [directoryUsers, allUsers] = await Promise.all([
        userApiClient.getUsers(),
        allWirUsers.length > 0
          ? Promise.resolve(allWirUsers)
          : wellGuardianApiClient.wirUsersList(READ_ONLY_WIR_USER, 'NA'),
      ]);
      const isUserInDirectory = hasDirectoryUser(directoryUsers, user);
      applyAffiliateAccess(allUsers, value, isUserInDirectory);
    } catch {
      setIsDecommissioned(true);
      setAffiliateAccessCheckFailed(true);
    } finally {
      setIsCountryLoading(false);
    }
  }, [user, allWirUsers, value, applyAffiliateAccess]);

  const handleContinueToAffiliate = () => {
    if (!canContinueToAffiliate || isCheckingAffiliateAccess) {
      return;
    }

    setDismissedAffiliateNotice(`${user?.email}:${user?.igg}:${country}`);
    setAffiliateAccessCheckFailed(false);
    setIsDecommissioned(false);
  };

  const handleDecommissionedAccessConfirm = async () => {
    if (!user || isCheckingAffiliateAccess) return;

    setIsCheckingAffiliateAccess(true);
    setAffiliateAccessCheckFailed(false);
    try {
      const [allUsers, directoryUsers] = await Promise.all([
        wellGuardianApiClient.wirUsersList(READ_ONLY_WIR_USER, 'NA', true),
        userApiClient.getUsers(),
      ]);
      const isUserInDirectory = hasDirectoryUser(directoryUsers, user);
      setConfirmedNoUkAccessForUser(
        countryListCheck(allUsers, user).includes(CountryData.unitedKingdom)
          ? null
          : `${user.email}:${user.igg}`,
      );
      setValue('');
      setDismissedAffiliateNotice(null);
      dispatch(updateAllWIRUsers(allUsers));
      applyAffiliateAccess(allUsers, '', isUserInDirectory);
    } catch {
      setAffiliateAccessCheckFailed(true);
    } finally {
      setIsCheckingAffiliateAccess(false);
    }
  };

  const userInitials = useMemo(
    () =>
      user?.firstName && user?.lastName
        ? `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`
        : '?',
    [user],
  );

  useEffect(() => {
    fetchUsersList();
  }, [fetchUsersList]);

  function getCountDisplayed(count: number | undefined) {
    if (!count || count <= 0) return 0;

    return count > 99 ? '99+' : `${count}`;
  }

  const handleTIPSelect = (tip?: string, country?: string) => {
    if (tip) {
      navigate(generatePath(PATHS.WELL_GUARDIAN_WIR_CREATION, { wirId: tip, country: country }));
    }
  };

  const handleCount = (tip: pendingPhase[]) => {
    const data = tip.filter(x => x.userId === user?.igg);
    const totalPendingSubTaskCount = data.reduce((total, obj) => {
      return total + obj.pendingSubtaskCount;
    }, 0);

    return (
      <span className={styles.gapArea}>
        <span className={styles.countText}>
          {totalPendingSubTaskCount > 9 ? totalPendingSubTaskCount : `0${totalPendingSubTaskCount}`}
        </span>
      </span>
    );
  };

  const getDueDateStatus = (dueDateStatus: string | undefined) => {
    if (dueDateStatus === StatusTypes.ON_TRACK) {
      return (
        <Tooltip title={StatusTypes.ON_TRACK} arrow={true}>
          <div className={styles.status}>
            <div className={styles.statusGreen} />
          </div>
        </Tooltip>
      );
    } else if (dueDateStatus === StatusTypes.BEHIND_SCHEDULE) {
      return (
        <Tooltip title={StatusTypes.BEHIND_SCHEDULE} arrow={true}>
          <div className={styles.status}>
            <div className={styles.statusOrange} />
          </div>
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title={StatusTypes.AT_RISK} arrow={true}>
          <div className={styles.status}>
            <div className={styles.statusRed} />
          </div>
        </Tooltip>
      );
    }
  };

  let teamsUrl = '';
  if (countryState === CountryData.unitedKingdom) {
    teamsUrl =
      window.location.pathname === PATHS.WELL_GUARDIAN_INTERVENTIONS
        ? URLData.TeamsWI_UK
        : URLData.TeamsWH_UK;
  } else if (countryState === CountryData.denmark) {
    teamsUrl = URLData.TeamsWH_DK;
  } else if (countryState === CountryData.nigeria) {
    teamsUrl = URLData.TeamsWH_NG;
  } else if (countryState === CountryData.angola) {
    teamsUrl = URLData.TeamsWH_AG;
  } else if (countryState === CountryData.congo) {
    teamsUrl = URLData.TeamsWH_CG;
  } else if (countryState === CountryData.brazil) {
    teamsUrl = URLData.TeamsWH_BZ;
  } else if (countryState === CountryData.iraq) {
    teamsUrl = URLData.TeamsWH_IQ;
  } else if (countryState === CountryData.argentina) {
    teamsUrl = URLData.TeamsWH_AR;
  }

  let toolTipHelp: any;
  if (user) {
    toolTipHelp = loading ? (
      <CircularProgress size={50} color="inherit" />
    ) : (
      <div className={styles.helpSettings}>
        <a href={teamsUrl} target="_blank" rel="noreferrer noopener" className={styles.teams}>
          <img src={teamsIcon} alt="" className={styles.teamsIcon} />
          <p className={styles.support}>WG Help/Support {'\n'}Teams Channel</p>
        </a>
        <a
          href={URLData.UserManual}
          target="_blank"
          rel="noreferrer noopener"
          className={styles.userManual}
        >
          <img src={userManualIcon} alt="" className={styles.groupsIcon} />
          <p className={styles.support}>Release Notes</p>
        </a>
      </div>
    );
  }

  let toolTipLabel: any;

  if (user) {
    toolTipLabel = (
      <>
        {loading ? (
          <CircularProgress size={50} color="inherit" />
        ) : (
          <>
            <div className={styles.rowReload}>
              <span className={styles.heading}>
                <span
                  className={styles.subHeading}
                >{`${user?.firstName?.toUpperCase()}  ${user?.lastName?.toUpperCase()}`}</span>
                <span>&nbsp;is having total&nbsp;</span>
                <span className={styles.subHeading}>{getCountDisplayed(totalCount) || 0}</span>
                <span>&nbsp;pending subTasks</span>
              </span>
              <div data-testid="count" className={styles.reload} onClick={() => setCount(true)}>
                <img src={reloadIcon} alt="" />
              </div>
            </div>
            {isEmpty(pendingStatus) ? (
              <span>{NOT_APPLICABLE}</span>
            ) : (
              <TableContainer className={styles.tableContainer}>
                <Table>
                  <TableHead>
                    <TableRow className={styles.tableHeaderRow}>
                      {headCells.map(headCell => (
                        <TableCell
                          width={headCell.width}
                          key={headCell.id}
                          align="left"
                          className={styles.tableHeadCell}
                        >
                          {headCell.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {pendingStatus?.map(tip => (
                      <TableRow key={tip.wirNumber} className={styles.tableBodyRow} hover>
                        <TableCell
                          className={styles.largeTableCell}
                          onClick={() => handleTIPSelect(tip.wirNumber, tip.country)}
                        >
                          <div className={styles.grayTag}>{tip.wirNumber}</div>
                        </TableCell>
                        <TableCell className={styles.tableBodyCell}>
                          {handleCount(tip.pendingAction)}
                        </TableCell>
                        <TableCell className={styles.largeTableBodyCell}>{tip.well}</TableCell>
                        <TableCell className={styles.largeTableBodyCell}>
                          {getPhaseName(intl, tip.state, countryState)}
                        </TableCell>
                        <TableCell className={styles.tableBodyCell}>
                          {getDueDateStatus(tip.dueDateStatus)}
                        </TableCell>
                        <TableCell className={styles.largeTableBodyCell}>
                          {tip.userNameInterventionEngineer ?? NOT_APPLICABLE}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </>
        )}
      </>
    );
  }

  return (
    <header className={styles.headerContainer} data-testid="header-well-guardian">
      <Dialog
        open={isDecommissioned}
        fullWidth
        fullScreen
        maxWidth="xs"
        classes={{ paper: styles.decommissionedScreen }}
        aria-labelledby="decommissioned-affiliate-message"
        aria-describedby="decommissioned-affiliate-message"
      >
        <SvgIcon
          className={styles.decommissionedIcon}
          viewBox="0 0 64 72"
          data-testid="decommissioned-page-icon"
        >
          <path
            d="M12 3h26l14 14v52H12V3Zm26 0v15h14M23 33v5m17-5v5M23 54c4-8 13-8 17 0"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </SvgIcon>
        <DialogContent className={styles.accessDialogContent}>
          <DialogContentText
            id="decommissioned-affiliate-message"
            className={styles.accessDialogMessage}
          >
            {intl.formatMessage({
              id: 'wellGuardian.decommissionedAffiliateAccess',
            })}
          </DialogContentText>
        </DialogContent>
        {affiliateAccessCheckFailed && (
          <Alert severity="error">
            {intl.formatMessage({ id: 'wellGuardian.affiliateAccessCheckFailed' })}
          </Alert>
        )}
        <DialogActions className={styles.accessDialogActions}>
          {canContinueToAffiliate && (
            <Button
              variant="outlined"
              disabled={isCheckingAffiliateAccess}
              onClick={handleContinueToAffiliate}
            >
              {intl.formatMessage({ id: 'wellGuardian.continueToAffiliate' })}
            </Button>
          )}
          {isUserInDirectory && confirmedNoUkAccessForUser !== `${user?.email}:${user?.igg}` && (
            <Button
              variant="contained"
              className={styles.accessDialogButton}
              disabled={isCheckingAffiliateAccess}
              onClick={handleDecommissionedAccessConfirm}
              startIcon={
                isCheckingAffiliateAccess ? (
                  <CircularProgress size={16} color="inherit" />
                ) : undefined
              }
            >
              {intl.formatMessage({ id: 'button.ok' })}
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <Grid direction="row" container className={styles.pageHeader}>
        <Grid direction="row" container>
          {getWellGuardianHeader(currentPath)}
        </Grid>
        <Grid direction="row" container className={styles.rightHeadContainer}>
          {(isCountryLoading || countryList.length > 0) && (
            <div className={styles.countryField}>
              {isCountryLoading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                <WIRField
                  id="input-country"
                  slotProps={{
                    input: {
                      className: canSelectCountry
                        ? styles.fieldCountryDropdownInput
                        : styles.fieldCountryInput,
                      startAdornment: (
                        <InputAdornment
                          position="start"
                          className={
                            canSelectCountry ? styles.enableCountryFlagIcon : styles.countryFlagIcon
                          }
                        >
                          {CountryFlagIcon(country)}
                        </InputAdornment>
                      ),
                    },
                    inputLabel: {
                      className: canSelectCountry
                        ? `${styles.fieldCountryLabel} ${styles.enabledCountryContent}`
                        : styles.fieldCountryLabel,
                    },
                    select: {
                      className: styles.selectCountryRoot,
                      renderValue: selected =>
                        intl.formatMessage({ id: `wellGuardian.country.${selected}` }),
                      MenuProps: {
                        classes: { paper: styles.countryMenuForcePos },
                      },
                    },
                  }}
                  onChange={event => {
                    setDismissedAffiliateNotice(null);
                    setAffiliateAccessCheckFailed(false);
                    dispatch(updateMapCountryState(false));
                    setValue(event.target.value);
                    dispatch(updateSelectedSite('ALL' as SiteType));
                    dispatch(updateSelectedAsset('ALL' as AssetType));
                    dispatch(updateSortedWells([]));
                    localStorage.setItem(COUNTRY_CODE, event.target.value);
                  }}
                  value={
                    canSelectCountry
                      ? DROPDOWN_COUNTRIES.includes(country as CountryData)
                        ? country
                        : ''
                      : toNormalCase(country)
                  }
                  disabled={!canSelectCountry}
                  select={canSelectCountry}
                >
                  {(canSelectCountry ? DROPDOWN_COUNTRIES : countryList).map(country => (
                    <MenuItem dense value={country} key={country} className={styles.menuLink}>
                      <Link
                        className={
                          canSelectCountry
                            ? `${styles.linkText} ${styles.enabledCountryContent}`
                            : styles.linkText
                        }
                        to={handleLinkChange()}
                        key={country}
                      >
                        {CountryFlagIcon(country)}
                        {intl.formatMessage({ id: `wellGuardian.country.${country}` })}
                      </Link>
                    </MenuItem>
                  ))}
                </WIRField>
              )}
            </div>
          )}
          {window.location.pathname === PATHS.WELL_GUARDIAN_WELL_HEALTH_HOME && (
            <div className={styles.downloadHeader}>
              {downloadValue ? (
                <CircularProgress size={25} color="inherit" />
              ) : (
                <div>
                  <Tooltip title="Download Well Reviews for all the wells as PDF">
                    <div
                      className={
                        !isSuperUserOnWirSubModule ? styles.downloadDisable : styles.download
                      }
                      onClick={() => {
                        dispatch(updateAllReviewsDownload(true));
                      }}
                    >
                      <img src={downloadIcon} alt="" className={styles.downloadIcon} />
                    </div>
                  </Tooltip>
                </div>
              )}
            </div>
          )}
          {isSuperUserOnWirSubModule && (
            <Grid direction="row">
              <SettingsIcon
                className={styles.settingsIcon}
                onClick={() => setOpenUserRoleSettingsModal(true)}
              />
            </Grid>
          )}
          <Tooltip classes={{ tooltip: styles.tooltipsHelp }} title={toolTipHelp} arrow={true}>
            <Grid direction="row">
              <Help className={styles.helpIcon} />
            </Grid>
          </Tooltip>
          <Tooltip classes={{ tooltip: styles.tooltipsBG }} title={toolTipLabel} arrow={true}>
            <Grid direction="row">
              <div>
                <Avatar classes={{ root: styles.avatar }}>{userInitials}</Avatar>
              </div>
              {totalCount > 0 ? (
                <div className={styles.linkCount}>{getCountDisplayed(totalCount)}</div>
              ) : (
                <div className={styles.linkCount}>{getCountDisplayed(0)}</div>
              )}
            </Grid>
          </Tooltip>
        </Grid>
      </Grid>
      <WellGuardianToolbar path={currentPath} />
      <UserRoleSettingsModal
        modalOpen={openUserRoleSettingsModal}
        cancelMethod={() => {
          setOpenUserRoleSettingsModal(false);
          setSearchText('');
        }}
        searchText={searchText}
        setSearchText={setSearchText}
      />
    </header>
  );
};

export default HeaderWellGuardian;
